import * as React from 'react';
import { isTextInputElement } from 'owa-timestream-asset-sdk';
import { getLastScrollTime } from '../viewstate';

/**
 * This code prevents the browser from doing the default behaivor onWheel.
 *
 * In the canvas, we do not want the default browser behaivors to happen onWheel,
 * because we have our own handling (see zoomByWheel and panByWheel).
 *
 * For example, onWheel gets fired when you use the touchpad and you drag two-fingers left/right. The default behaivor here is going back or forward in history.
 *
 * There are some cases where we do not want to prevent the default behaivor.
 * For example, in scollable assets, we do not want to prevent the default behaivor onWheel, because this will prevent the asset from scrolling.
 * In cases like these our current solution is to prevent the wheel event from propogating to this point by using `useWheelStopPropogating`
 */
export default function useDisableScrollZoomAndNavigation(target: React.RefObject<HTMLDivElement>) {
    React.useEffect(() => {
        target.current!.addEventListener('wheel', disableScrollZoomAndNavigation, {
            passive: false,
        });
        return () => {
            target.current!.removeEventListener('wheel', disableScrollZoomAndNavigation);
        };
    }, [target.current]);
}

function disableScrollZoomAndNavigation(e: WheelEvent) {
    const target = e.target as HTMLInputElement | null;
    if (target) {
        const isShowingVerticalScrollBar = target.scrollHeight > target.clientHeight;
        const isShowingHorizontalScrollBar = target.scrollWidth > target.clientWidth;

        // we want to allow scrolling of an asset if the user isn't already scrolling on the canvas
        const lastScrollTime = getLastScrollTime();
        const isRecentlyScrolling = Date.now() < lastScrollTime + 1000;
        if (
            !isShowingVerticalScrollBar &&
            !isShowingHorizontalScrollBar &&
            !isTextInputElement(target) &&
            isRecentlyScrolling
        ) {
            e.preventDefault();
        }
    }
}
